import type { ReactNode } from 'react';

/** Pill filter chip (DESIGN → Components). ≥ 44 px tall touch area via padding. */
export function Chip({
	selected,
	onClick,
	children,
	compact = false,
}: {
	selected: boolean;
	onClick: () => void;
	children: ReactNode;
	/** Narrower padding, for rows that must fit 360 px with other controls. */
	compact?: boolean;
}) {
	return (
		<button
			type="button"
			aria-pressed={selected}
			onClick={onClick}
			className={`text-caption flex min-h-10 shrink-0 items-center gap-1.5 rounded-full border ${compact ? 'px-3' : 'px-4'} font-semibold whitespace-nowrap shadow-md transition-colors duration-150 ${
				selected
					? 'bg-primary border-primary text-text shadow-primary/30'
					: 'bg-surface/90 border-border text-text'
			}`}
		>
			{children}
		</button>
	);
}
